import script from "./BuyerDashboardGapSizeBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerDashboardGapSizeBarChart.vue?vue&type=script&setup=true&lang=js"

import "./BuyerDashboardGapSizeBarChart.vue?vue&type=style&index=0&id=57868d74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57868d74"]])

export default __exports__